import { Permission } from '../../../legacy/common/types'
import AccessControl from '../../../legacy/components/AccessControl/AccessControl'
import { type AccessControlConfig } from '../../../legacy/components/AccessControl/accessControl.utils'

// Mirrors AppAdminSectionAccessControl — reuse the same admin gate, do not weaken it.
export const NoticeBannersAccessControl: AccessControlConfig = {
  permissions: AccessControl.oneOf([Permission.AdminPanel, Permission.GlobalAdmin]),
}
